import axios from 'axios';

const API_BASE_URL = 'https://api.wtoptax.com'; // 운영 도메인

// const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

let isFetchingConsent = false;

// ✅ 공지사항 조회
export const fetchNotification = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/v1/notification`, {
      timeout: 5000,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    });
    const { result, message } = response.data;
    return { show: result === 'True', message };
  } catch (error) {
    console.error('fetchNotification 오류:', error);
    return { show: false };
  }
};

// ✅ 서비스 이용가능 조회 (홈택스 이용 가능한지)
export const checkEnable = async () => {
  try {
    // await sleep(5000);
    const response = await axios.get(`${API_BASE_URL}/api/v1/enable`, {
      timeout: 5000, // 5초 타임아웃
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    });

    console.log("checkEnable response");
    console.log(response);
    const { result, message } = response.data;

    if (result === 'True') {
      return { success: true };
    } else {
      return { success: false, message };
    }
  } catch (error) {
    console.error('API 호출 에러:', error);
    return { success: false, message: '알 수 없는 에러가 발생했습니다.' };
  }
};

// ✅ 간편인증 로그인 요청
export const loginRequest = async (data) => {
    try {
      // await sleep(5000);
      const response = await axios.post(`${API_BASE_URL}/api/v1/login_request`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      });
  
      console.log("loginRequest response")
      console.log(response)
      const { result, message, sid } = response.data;

      if (result === true) {
        return { success: true, sid };
      } else {
        return { success: false, message };
      }
    } catch (error) {
      console.error('loginRequest 오류:', error);
      return { success: false, message: '로그인 요청 중 에러가 발생했습니다.' };
    }
  };
  
  // ✅ 간편인증 로그인 결과
  export const loginResult = async (sid) => {
    try {
      // await sleep(5000);
      const response = await axios.get(`${API_BASE_URL}/api/v1/login_result`, {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'sid': sid,
        },
      });
  
      console.log("loginResult response")
      console.log(response)
      const { result, message } = response.data;

      if (result === true) {
        return { success: true };
      } else {
        return { success: false, message };
      }
    } catch (error) {
      console.error('loginResult 오류:', error);
      return { success: false, message: '로그인 결과 확인 중 에러가 발생했습니다.' };
    }
  };
  
  // ✅ 수임 동의
  export const consent = async (sid) => {

    // 중복 호출 방지
    if (isFetchingConsent) {
      console.warn('이미 consent API 호출 중입니다. 중복 호출을 무시합니다.');
      return { success: false, message: '요청 중입니다. 잠시 후 다시 시도해 주세요.' };
    }
    isFetchingConsent = true;

    try {
      const response = await axios.get(`${API_BASE_URL}/api/v1/consent`, {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'sid': sid,
        },
      });

      console.log("consent response")
      console.log(response)
      const { result, message } = response.data;

      if (result === true) {
        return { success: true };
      } else {
        return { success: false, message };
      }
    } catch (error) {
      console.error('consent 오류:', error);
      return { success: false, message: '수임동의 처리 중 에러가 발생했습니다.' };
    } finally {
      isFetchingConsent = false;
    }
  };